import { type Monitor, Signal } from "@suse-o11y/signal";

import type { Point } from "~/tools/point";

export interface TimelineHoveredLine {
	position: Point;
	popoverId: string;
}

export class TimelineLineState {
	private readonly linePopup = Signal<TimelineHoveredLine>();
	public readonly hoveredLine = Signal<TimelineHoveredLine>();

	public getLinePopup(monitor: Monitor): undefined | TimelineHoveredLine {
		return this.hoveredLine.read(monitor) ?? this.linePopup.read(monitor);
	}

	public setLinePopup(event: undefined | TimelineHoveredLine): void {
		this.linePopup.write(event);
	}
}
